import { API } from "aws-amplify";
import { getApplication } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_APPLICATION_INFO: APITypes.Application = {
  id: "",
  startDate: "",
  endDate: "",
  __typename: "Application",
  status: APITypes.ApplicationStatusType.Submitted,
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const getApplicationInfo = async (
  leaseID: string
): Promise<LoaderData<APITypes.Application>> => {
  try {
    const response = (await API.graphql({
      query: getApplication,
      variables: {
        id: leaseID,
      },
    })) as { data?: APITypes.GetApplicationQuery };

    return {
      success: true,
      data: response.data?.getApplication || EMPTY_APPLICATION_INFO,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_APPLICATION_INFO,
      error,
    };
  }
};
